import React, { FC } from 'react';

import { useMediaQuery } from '../../../hooks/useMediaQuery';
import { useUser } from '../../../hooks/useUser';
import { AppRoute, BuildingScreenTab, hasPermission } from '../../../utils/navigation';
import { AreaOfExpertise, UserType } from '../../../types/user';
import { BuildingDetails } from '../../../types/building';

import { DropDownMenu } from './dropDownMenu';
import { DropDownMenuItem } from './dropDownMenuItem';
import { SideMenu } from './styledComponents';
import { SideMenuButton } from './sideMenuButton';

interface Props {
  building: BuildingDetails;
}

export const BuildingMenu: FC<Props> = ({ building }) => {
  const { smScreen, xsScreen } = useMediaQuery();
  const { user } = useUser();

  const hasDocumentAccess = building.kanEnergimerkesAvPrivatPerson && hasPermission(AppRoute.SOKNAD, user);
  const energiplanEnabled = window.config.VITE_FEATURE_ENERGIPLAN_ENABLED;

  const hasEnergyRatingAccess =
    building.kanEnergimerkesAvPrivatPerson ||
    (!building.kanEnergimerkesAvPrivatPerson && user?.fagomrader?.includes(AreaOfExpertise.BYGNINGSEKSPERT));

  const hasEnergyAssessmentAccess =
    user?.type === UserType.EXPERT &&
    (user?.fagomrader?.includes(AreaOfExpertise.KJELOGVARMEANLEGG) ||
      user?.fagomrader?.includes(AreaOfExpertise.VENTILASJONOGKJOLEANLEGG));

  const hasRegisteredMeasures = building.gyldigeEnergiattester.length > 0;

  // Dropdown menu for small screens
  if (smScreen || xsScreen) {
    return (
      <DropDownMenu>
        <DropDownMenuItem tab={BuildingScreenTab.ENERGY_CERTIFICATE} />
        <DropDownMenuItem tab={BuildingScreenTab.ABOUT} />
        {hasEnergyRatingAccess && <DropDownMenuItem tab={BuildingScreenTab.ENERGY_RATING} />}
        {hasEnergyAssessmentAccess && <DropDownMenuItem tab={BuildingScreenTab.ENERGY_ASSESSMENT} />}
        {hasRegisteredMeasures && <DropDownMenuItem tab={BuildingScreenTab.ENERGY_SAVING_MEASURES} />}
        {hasDocumentAccess && <DropDownMenuItem tab={BuildingScreenTab.DOCUMENTS} />}
        {energiplanEnabled && hasDocumentAccess && <DropDownMenuItem tab={BuildingScreenTab.ENERGIPLAN} />}
      </DropDownMenu>
    );
  }

  // Tab menu for larger screens
  return (
    <SideMenu>
      <SideMenuButton tab={BuildingScreenTab.ENERGY_CERTIFICATE} />
      <SideMenuButton tab={BuildingScreenTab.ABOUT} />
      {hasEnergyRatingAccess && <SideMenuButton tab={BuildingScreenTab.ENERGY_RATING} />}
      {hasEnergyAssessmentAccess && <SideMenuButton tab={BuildingScreenTab.ENERGY_ASSESSMENT} />}
      {hasRegisteredMeasures && <SideMenuButton tab={BuildingScreenTab.ENERGY_SAVING_MEASURES} />}
      {hasDocumentAccess && <SideMenuButton tab={BuildingScreenTab.DOCUMENTS} />}
      {energiplanEnabled && hasDocumentAccess && <SideMenuButton tab={BuildingScreenTab.ENERGIPLAN} />}
    </SideMenu>
  );
};
